module.exports = __webpack_public_path__ + "img/3.606711e.png";